import styled from 'styled-components';

// ===== 布局样式 =====
export const PageGrid = styled.div`
  /* 弹性布局：适应侧边栏展开/折叠 */
  display: flex;
  gap: 24px;
  align-items: start;
  padding-top: 20px;
  padding-bottom: 120px;
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;

  /* 移动端改为单列 */
  @media (max-width: 968px) {
    flex-direction: column;
    padding-top: 20px;
  }
`;

// 小图预览列
export const SmallPreviewCol = styled.div`
  background: transparent;
  border: none;
  border-radius: 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 140px;
  min-width: 140px;
  max-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;

  /* 滚动条更接近参考图（Webkit） */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  @media (max-width: 968px) {
    display: none;
  }
`;

// 小图预览图片（A4比例）
export const SmallPreview = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1.4142;
  height: auto;
  object-fit: contain;
  background: #f3f4f6;
  display: block;
  cursor: pointer;
`;


export const Page = styled.div`
  background: #f9fafb;
  min-height: 100vh;
  padding: 24px 32px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
`;

export const BackButton = styled.button`
  margin-top: 32px;
  margin-left: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #9ca3af;
    background: #f9fafb;
  }
`;

export const QuotaPill = styled.div`
  margin-top: 32px;
  margin-right: 32px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const PreviewCol = styled(Column)`
  overflow: hidden;
  flex: 1;
  max-width: 700px;
  min-width: 400px;
  padding: 24px;
  background: #f3f4f6;
  border-radius: 0;

  /* 让A4预览在容器内更像参考图：适当留白 */
  display: flex;
  justify-content: center;

  @media (max-width: 968px) {
    max-width: 100%;
    min-width: 100%;
  }
`;

export const PreviewImg = styled.img`
  width: 100%;
  max-width: 652px;
  aspect-ratio: 1 / 1.4142;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  background: #ffffff;
  display: block;
  border-radius: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
`;

export const InfoCol = styled(Column)`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  width: 380px; /* 新增：固定宽度 */
  flex-shrink: 0; /* 新增：防止被压缩 */
`;
export const Name = styled.h1`
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
`;

export const DownloadButton = styled.button`
  width: auto;
  min-width: 220px;
  max-width: 280px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: none;
  border-radius: 10px;
  padding: 14px 20px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    box-shadow: 0 2px 8px rgba(156, 163, 175, 0.3);
    transform: none;
  }

  /* 配额信息在右侧 */
  > span:last-child {
    flex-shrink: 0;
    padding-left: 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.35);
    font-size: 13px;
    font-weight: 500;
    opacity: 0.95;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    letter-spacing: 0.3px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 20px 0;
`;

export const StatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  color: #6b7280;
  font-weight: 500;
  font-size: 14px;
`;

export const Stat = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
`;

export const InfoTable = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 16px 12px;
`;

export const InfoKey = styled.div`
  color: #6b7280;
  font-weight: 500;
  font-size: 14px;
`;

export const InfoVal = styled.div`
  color: #111827;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Tag = styled.span`
  border: 1px solid #d1d5db;
  background: #f9fafb;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
`;

export const Box = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 40px;
  color: #6b7280;
  text-align: center;
  font-size: 16px;
`;

export const ErrorBox = styled(Box)`
  color: #b91c1c;
`;
